import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const UploadMeta: ComponentMeta = {
  componentName: "Upload",
  package: "@mijadesign/web",
  title: "上传",
  description: "文件上传控件，支持点击或拖拽上传",
  category: ComponentCategory.FORM,
  icon: "UploadOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "accept",
      label: "接受文件类型",
      type: PropType.STRING,
      description: "如：.png,.jpg,.pdf",
      group: "基础",
    },
    {
      name: "multiple",
      label: "多文件上传",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "maxCount",
      label: "最大文件数",
      type: PropType.NUMBER,
      description: "限制上传文件数量，0 表示不限制",
      group: "限制",
    },
    {
      name: "fileList",
      label: "文件列表",
      type: PropType.ARRAY,
      group: "数据",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "listType",
      label: "列表类型",
      type: PropType.ENUM,
      defaultValue: "text",
      options: [
        { label: "文本", value: "text" },
        { label: "图片", value: "picture" },
        { label: "图片卡片", value: "picture-card" },
      ],
      group: "展示",
    },
    {
      name: "showUploadList",
      label: "显示文件列表",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "展示",
    },
    {
      name: "drag",
      label: "拖拽上传",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "action",
      label: "上传地址",
      type: PropType.STRING,
      description: "上传的 URL 地址",
      group: "配置",
    },
    {
      name: "headers",
      label: "请求头",
      type: PropType.JSON,
      description: '设置上传请求头，如：{ "Authorization": "Bearer token" }',
      group: "配置",
    },
    {
      name: "data",
      label: "附加数据",
      type: PropType.JSON,
      description: "上传时附带的额外参数",
      group: "配置",
    },
  ],
  defaultProps: {
    action: "/api/upload",
    showUploadList: true,
    listType: "text",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Upload",
  },
  snippet: {
    componentName: "Upload",
    package: "@mijadesign/web",
    props: { action: "/api/upload", showUploadList: true },
  },
};
